// Un solo interruptor para las dos plataformas: VITE_MODO=demo | supabase.
// demo      → datos falsos en el navegador (localStorage), sin backend ni llaves.
// supabase  → VITE_SUPABASE_URL + VITE_SB_PUBLISHABLE_KEY del proyecto de ESTA instalación.
export type Modo = "demo" | "supabase";

export const MODO: Modo =
  import.meta.env.VITE_MODO === "supabase" ? "supabase" : "demo";

export const esDemo = MODO === "demo";

/** Nombre de la instalación (p. ej. «Agencia» o «AuTeam · Carranza»), solo para mostrar. */
export const NOMBRE_INSTALACION: string =
  import.meta.env.VITE_NOMBRE_INSTALACION || "Agencia de reclutamiento";

export function validarEntorno(): string | null {
  if (MODO !== "supabase") return null;
  const faltan = ["VITE_SUPABASE_URL", "VITE_SB_PUBLISHABLE_KEY"].filter(
    (k) => !import.meta.env[k],
  );
  return faltan.length
    ? `Falta configurar ${faltan.join(" y ")} en el archivo .env de esta instalación (ver README).`
    : null;
}
